const How = () => {
    return (
        <section className = "flex flex-col gap-4 flex-1 overflow-y-auto p-16">
            <div className = "bg-white shadow-lg rounded-lg w-fit py-4 px-8">
                <h2 className = "text-gray-800 text-2xl font-semibold">Zipped</h2>
                <p className = "mt-2 text-justify text-gray-600">
                    Payment processing solutions address a much larger audience by using the distributed ledger to transfer payments in conventional currencies. 
                    This enables them to bypass existing banking infrastructure, with the goal of accelerating payment.
                </p>
            </div>
            <div className = "bg-white shadow-lg rounded-lg w-fit py-4 px-8">
                <h2 className = "text-gray-800 text-2xl font-semibold">Zeroed</h2>
                <p className = "mt-2 text-justify text-gray-600">
                    Blockchain could reduce the operational and compliance costs of paper-based trade by 10-to-15 percent from individuals till banking firms.
                </p>
            </div>
            <div className = "bg-white shadow-lg rounded-lg w-fit py-4 px-8">
                <h2 className = "text-gray-800 text-2xl font-semibold">Zealous</h2>
                <p className = "mt-2 text-justify text-gray-600">
                    Smart contracts being really smart,  are self-executing programs stored on the distributed ledger that automatically execute payments 
                    when specific conditions are met.
                </p>
            </div>
            <div className = "bg-white shadow-lg rounded-lg w-fit py-4 px-8">
                <h2 className = "text-gray-800 text-2xl font-semibold">Zenda</h2>
                <p className = "mt-2 text-justify text-gray-600">
                    Secured payments with full visibility, accountability and no fraudish accidents crossed.
                </p>
            </div>
        </section>
    )
}

export default How